import { openJournalSidebar } from 'features/journal';

import { SidebarSubHeader, useSidebarContext } from 'shared/components/Sidebar';

export const JournalRepliesHeader = () => {
  const { user, participantEmail, participantId, filters } =
    useSidebarContext();

  const handleBackBtnClick = () => {
    openJournalSidebar({ user, participantEmail, participantId, filters });
  };

  return (
    <SidebarSubHeader
      mainSidebarTitle="Journal"
      onBackButtonClick={handleBackBtnClick}
    />
  );
};
